// import React, { useState } from 'react';
// import './FAQ.css'

// const FAQ = () => {
//   const [activeFAQ, setActiveFAQ] = useState(null);

//   const toggleFAQ = (index) => {
//     setActiveFAQ(activeFAQ === index ? null : index);
//   };

//   const faqs = [
//     {
//       question: 'What is the main objective of the Quran academy?',
//       answer: 'The primary goal of the Quran academy is to provide high-quality education on the Quran, including its recitation, memorization, and understanding. We aim to foster a deep connection with the Quran and ensure that our students gain comprehensive knowledge about its teachings and practices.'
//     },
//     {
//       question: 'What types of courses are offered at the Quran academy?',
//       answer: 'Our academy offers a variety of courses including Quranic recitation, Tajweed (rules of Quranic pronunciation), Hifz (memorization of the Quran), Noorani Qaida (basic Quranic reading), and Islamic studies. Each course is designed to cater to different levels of expertise and age groups.'
//     },
//     {
//       question: 'How can I enroll my child in a Quranic course?',
//       answer: 'To enroll your child, please visit our website and fill out the registration form available on the "Enroll Now" page. You can also contact our administrative office directly for assistance. Our team will guide you through the process and provide you with all necessary details.'
//     },
//     {
//       question: 'Are the classes conducted online or in-person?',
//       answer: 'We offer both online and in-person classes to accommodate different preferences. Online classes are conducted via Google Meet, Zoom, and Skype, allowing flexibility and accessibility for students from various locations. In-person classes are held at our academy\'s premises. You can choose the option that best suits your convenience.'
//     },
//     {
//       question: 'What is the duration of each course?',
//       answer: 'The duration of each course varies depending on the level and intensity. For example, a basic Quranic recitation course might last for 3 months, while a comprehensive Hifz program may extend over several years. Specific course durations are detailed on our website or can be obtained from our administrative office.'
//     },
//     {
//       question: 'Are there any prerequisites for joining the advanced Quranic courses?',
//       answer: 'Yes, for advanced courses such as Tajweed or Hifz, it is recommended that students have a basic understanding of Quranic recitation. However, our academy provides foundational courses to prepare students before they advance to higher levels. Assessments may also be conducted to determine the appropriate level for each student.'
//     },
//     {
//       question: 'Can I get a certificate after completing a course?',
//       answer: 'Yes, upon successful completion of a course, students receive a certificate of achievement. This certificate acknowledges their hard work and progress, and can be a valuable addition to their educational or professional credentials.'
//     },
//     {
//       question: 'How can I contact the academy for further information?',
//       answer: 'For any additional information, you can contact us via email, phone, or by visiting our office. Contact details are available on our "Contact Us" page on the website. Our team is always ready to assist with any queries or concerns you may have.'
//     },
//   ];

//   return (
//     <section id="faq" className="faq">
//       <div className="container" data-aos="fade-up">
//         <div className="section-title">
//           <h2>Frequently Asked Questions</h2>
//         </div>
//         <ul className="faq-list accordion" data-aos="fade-up">
//           {faqs.map((faq, index) => (
//             <li key={index}>
//               <a
//                 href="#!"
//                 onClick={() => toggleFAQ(index)}
//                 className={activeFAQ === index ? '' : 'collapsed'}
//               >
//                 {faq.question}
//                 <i className={`bx ${activeFAQ === index ? 'bx-x icon-close' : 'bx-chevron-down icon-show'}`}></i>
//               </a>
//               <div
//                 id={`faq${index}`}
//                 className={`collapse ${activeFAQ === index ? 'show' : ''}`}
//                 data-bs-parent=".faq-list"
//               >
//                 <p>{faq.answer}</p>
//               </div>
//             </li>
//           ))}
//         </ul>
//       </div>
//     </section>
//   );
// };

// export default FAQ;
import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [activeFAQ, setActiveFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };

  const faqs = [
    {
      question: 'What is the main objective of the Quran academy?',
      answer: 'The primary goal of the Quran academy is to provide high-quality education on the Quran, including its recitation, memorization, and understanding. We aim to foster a deep connection with the Quran and ensure that our students gain comprehensive knowledge about its teachings and practices.'
    },
    {
      question: 'What types of courses are offered at the Quran academy?',
      answer: 'Our academy offers a variety of courses including Quranic recitation, Tajweed (rules of Quranic pronunciation), Hifz (memorization of the Quran), Noorani Qaida (basic Quranic reading), and Islamic studies. Each course is designed to cater to different levels of expertise and age groups.'
    },
    {
      question: 'How can I enroll my child in a Quranic course?',
      answer: 'To enroll your child, please visit our website and fill out the registration form available on the "Enroll Now" page. You can also contact our administrative office directly for assistance. Our team will guide you through the process and provide you with all necessary details.'
    },
    {
      question: 'Are the classes conducted online or in-person?',
      answer: 'We offer both online and in-person classes to accommodate different preferences. Online classes are conducted via Google Meet, Zoom, and Skype, allowing flexibility and accessibility for students from various locations. In-person classes are held at our academy\'s premises. You can choose the option that best suits your convenience.'
    },
    {
      question: 'What is the duration of each course?',
      answer: 'The duration of each course varies depending on the level and intensity. For example, a basic Quranic recitation course might last for 3 months, while a comprehensive Hifz program may extend over several years. Specific course durations are detailed on our website or can be obtained from our administrative office.'
    },
    {
      question: 'Are there any prerequisites for joining the advanced Quranic courses?',
      answer: 'Yes, for advanced courses such as Tajweed or Hifz, it is recommended that students have a basic understanding of Quranic recitation. However, our academy provides foundational courses to prepare students before they advance to higher levels. Assessments may also be conducted to determine the appropriate level for each student.'
    },
    {
      question: 'Can I get a certificate after completing a course?',
      answer: 'Yes, upon successful completion of a course, students receive a certificate of achievement. This certificate acknowledges their hard work and progress, and can be a valuable addition to their educational or professional credentials.'
    },
    {
      question: 'How can I contact the academy for further information?',
      answer: 'For any additional information, you can contact us via email, phone, or by visiting our office. Contact details are available on our "Contact Us" page on the website. Our team is always ready to assist with any queries or concerns you may have.'
    },
  ];

  return (
    <section id="faq" className="faq">
      <div className="container">
        <div className="section-title">
          <h2>Frequently <span style={{color:'#e67e22'}}>Asked Questions</span></h2>
        </div>
        <ul className="faq-list">
          {faqs.map((faq, index) => (
            <li key={index} className={`faq-item ${activeFAQ === index ? 'active' : ''}`}>
              <a
                href="#!"
                onClick={(e) => {
                  e.preventDefault(); // Prevent default anchor behavior
                  toggleFAQ(index);
                }}
                className={`faq-toggle ${activeFAQ === index ? 'active' : ''}`}
              >
                {faq.question}
                <i className={`bx ${activeFAQ === index ? 'bx-chevron-up' : 'bx-chevron-down'}`}></i>
              </a>
              <div className={`faq-content ${activeFAQ === index ? 'show' : ''}`}>
                <p>{faq.answer}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default FAQ;
